import { dapvApi } from 'services/providers/dapv';
import {
    PersonProjectEvent,
    GetPersonProjectEventsPayload,
    GetPersonProjectEventsResponse,
    CreatePersonProjectEventPayload,
    CreatePersonProjectEventsResponse,
    UpdatePersonProjectEventPayload,
    GetPersonProjectEventPayload
} from './event.types';
import { ApiResponse } from 'services/providers/dapv.types';

const eventApi = dapvApi.injectEndpoints({
    endpoints: (build) => ({
        getPersonProjectEvents: build.mutation<GetPersonProjectEventsResponse, GetPersonProjectEventsPayload>({
            query: ({ id }: GetPersonProjectEventsPayload) => {
                return {
                    url: `/app/projects/${id}/events`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<Array<PersonProjectEvent>>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getPersonProjectEvent: build.mutation<ApiResponse<PersonProjectEvent>, GetPersonProjectEventPayload>({
            query: ({ id, eventId }: GetPersonProjectEventPayload) => {
                return {
                    url: `/app/projects/${id}/events/${eventId}`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<PersonProjectEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        createPersonProjectEvent: build.mutation<CreatePersonProjectEventsResponse, CreatePersonProjectEventPayload>({
            query: ({ id, body }: CreatePersonProjectEventPayload) => {
                return {
                    url: `/app/projects/${id}/events`,
                    method: 'POST',
                    body
                };
            },
            transformResponse: (response: ApiResponse<PersonProjectEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        updatePersonProjectEvent: build.mutation<CreatePersonProjectEventsResponse, UpdatePersonProjectEventPayload>({
            query: ({ projectId, eventId, body }: UpdatePersonProjectEventPayload) => {
                return {
                    url: `/app/projects/${projectId}/events/${eventId}`,
                    method: 'PUT',
                    body
                };
            },
            transformResponse: (response: ApiResponse<PersonProjectEvent>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        }),
        getUserProjectEvents: build.mutation<GetPersonProjectEventsResponse, GetPersonProjectEventsPayload>({
            query: ({ id }: GetPersonProjectEventsPayload) => {
                return {
                    url: `/user/projects/${id}/events`,
                    method: 'GET'
                };
            },
            transformResponse: (response: ApiResponse<Array<PersonProjectEvent>>) => ({
                code: response.code,
                data: response.data,
                status: response.status
            })
        })
    })
});

export const {
    useGetPersonProjectEventsMutation,
    useGetPersonProjectEventMutation,
    useCreatePersonProjectEventMutation,
    useUpdatePersonProjectEventMutation,
    useGetUserProjectEventsMutation
} = eventApi;
